/**
 * Leaving the app for another site (spec 161): the forge's sign-in page.
 *
 * An object, not a bare function, so a DOM test can `vi.spyOn(navigation,
 * 'leaveFor')` — jsdom cannot navigate, and module mocks are not used here.
 */
export const navigation = {
  leaveFor(url: string): void {
    window.location.assign(url);
  },
};
